import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getAccessToken } from "../utilities/tokenUtils";

export const PublicRoute = ({ component: Component, ...rest }) => {
  const token = getAccessToken();
  return (
    <>
      <Route
        {...rest}
        render={(props) => {
          if (!token) {
            return <Component {...props} />;
          } else {
            return (
              <Redirect
                to={{
                  pathname: "/",
                  state: {
                    from: props.location,
                  },
                }}
              />
            );
          }
        }}
      />
    </>
  );
};
